import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ptBR from "./locales/pt-BR.json";

const i18n = i18next.createInstance();

function storedLanguage() {
  try {
    const language = typeof localStorage === "undefined" ? null : localStorage.getItem("bible.lang");
    return language === "en" || language === "pt-BR" ? language : "pt-BR";
  } catch {
    return "pt-BR";
  }
}

const documentLanguage = (language?: string) => language?.startsWith("en") ? "en" : "pt-BR";

function syncDocumentLanguage(language?: string) {
  if (typeof document === "undefined") return;
  const locale = documentLanguage(language);
  document.documentElement.lang = locale;
  document.title = i18n.t("app.documentTitle", { lng: locale });
}

i18n
  .use(initReactI18next)
  .on("languageChanged", syncDocumentLanguage);

export const i18nReady = i18n.init({
  lng: storedLanguage(),
  resources: {
    "pt-BR": { translation: ptBR },
    en: { translation: en },
  },
  fallbackLng: "pt-BR",
  supportedLngs: ["pt-BR", "en"],
  keySeparator: false,
  defaultNS: "translation",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
}).then(() => syncDocumentLanguage(i18n.resolvedLanguage));

export function chooseLanguage(language: "pt-BR" | "en") {
  localStorage.setItem("bible.lang", language);
  return i18n.changeLanguage(language);
}

export default i18n;
